/* eslint-disable no-unused-vars */
import { X_COUNTRY_CODE, X_VEHICLE_TYPE } from "../constants/api-constants";
import formQueryParams from "../utils/helpers/form-query-params";
import { getDeviceType } from "../utils/helpers/get-device-type";
import { API_VERSION_V1 } from "./api-version";
import parseCookie from "../utils/helpers/parse-cookie";
import { REFERRER_SOURCE } from "../constants/app-constants";
import {appUrl} from "../constants/url-constants";
import sanitizeItemsToLowercase from "../utils/helpers/sanitize-items-to-lowercase";
import { EXPERIMENT_TYPE } from "../constants/optimize-constants";

// eslint-disable-next-line max-statements
export default (api) => {
    const deviceType = getDeviceType();
    const getCheckoutSteps = (token, orderId) => {
        return api.get(`/v1/checkout-journey/step/${orderId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.car,
                SOURCE: deviceType
            }
        });
    };

    const createCheckoutSteps = (params, token) => {
        return api.post(`/v1/checkout-journey/step`, {...params}, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const updateCheckoutSteps = (params, token) => {
        return api.put(`/v1/checkout-journey/step/${params.orderId}`, {...params}, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const getTestDriveSteps = (token, orderId) => {
        return api.get(`/v1/test-drive-journey/step/${orderId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.car,
                SOURCE: deviceType
            }
        });
    };

    const createTestDriveSteps = (params, token) => {
        return api.post(`/v1/test-drive-journey/step`, {...params}, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const updateTestDriveSteps = (params, token) => {
        return api.put(`/v1/test-drive-journey/step/${params.orderId}`, {...params}, {
            headers: {
                Authorization: `Bearer ${token}`,
                SOURCE: deviceType
            }
        });
    };

    // eslint-disable-next-line max-params
    const getDeliveryAvailability = (secureToken, appointmentId, pincode, origincity, pickUp, originState, emiEnabled) => {
        return api.get(`/v1/availability?pincode=${pincode}&origincity=${origincity}&appointmentId=${appointmentId}&pickUp=${pickUp}&originState=${originState}&emiEnabled=${emiEnabled || false}`, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const getBookingSummary = (token, orderId) => {
        return api.get(`/v1/bookings/${orderId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const cancelOrder = (orderId, token, params) => {
        return api.put(`/v1/order/${orderId}/cancel${formQueryParams(params)}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: "CAR",
                SOURCE: deviceType
            }
        });
    };
    const fetchNudgeList = (token) => {
        return api.get(`/v1/alerts`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const closeNudgeList = (token, payload) => {
        return api.put(`/v1/alerts/suppress`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const getInhousePreApprovalLoanDetails = (token) => {
        return api.get(`/v1/preapproval/quote`, {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const getInhouseEligibility = (token) => {
        return api.get(`/v1/preapproval/me`, {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const updateInhousePreApprovalLoan = (token, uuid, payload) => {
        return api.post(`v1/preapproval/quote/${uuid}`, payload, {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const submitInhousePreApprovalLoan = (token, uuid, payload) => {
        return api.post(`v1/preapproval/submit/${uuid}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const inHouseFinanceFirstFinancePollApi = (uuid, token) => {
        return api.get(`/v1/preapproval/poll/${uuid}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const createTestDriveAvailability = (token, payload) => {
        return api.post(`/v1/test-drive/order`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                SOURCE: deviceType,
                referrerSource: parseCookie(REFERRER_SOURCE) || ""

            }
        });
    };

    const fetchInspectionReportDataApi = (token, vehicleId) => {
        return api.get(`/v1/inspection/${vehicleId}/report`, {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.car,
                SOURCE: deviceType
            }
        });
    };

    const fetchFilters = (token) => {
        return api.get("/v1/filter?showRevampedFilters=true", {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {})
            }});
    };

    const updateC2bTrade = (token, params) => {
        return api.put(`${API_VERSION_V1}c2b/trade/offer`, {...params}, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR
            }
        });
    };

    const submitC2bTrade = (token, params, orderId) => {
        return api.put(`${API_VERSION_V1}c2b/trade/order/${orderId}/submit`, {...params}, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR
            }
        });
    };

    const getDepositRangeValueInHouse = () => {
        return api.get(`/v1/deposit/range`, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const getSellbookings = (token) => {
        return api.get(`/v1/sell/bookings`, {
            headers: {
                Authorization: `Bearer ${token}`,
                SOURCE: deviceType
            }
        });
    };

    const getUnbookedSellbooking = (token) => {
        return api.get(`/v1/sell/unbooked`, {
            headers: {
                Authorization: `Bearer ${token}`,
                SOURCE: deviceType
            }
        });
    };

    const fetchListing = (params, queryString, token) => {
        return api.get(`/v1/vehicle${queryString ? `?${queryString}` : ``}`, {
            params,
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {})
            }},
        );
    };

    const fetchCarPricing = (token, appointmentId, queryString) => {
        return api.get(`/v1/pricing/${appointmentId}${queryString ? `?${queryString}` : ``}`, {
            headers: {
                SOURCE: deviceType,
                ...(token ?  {Authorization: `Bearer ${token}`} : {})
            }});
    };

    const getFinancePostPaymentApplication = (token, orderId) => {
        return api.get(`v1/finance/${orderId}/loan-application`, {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                SOURCE: deviceType
            }});
    };

    const patchFinancePostPaymentApplication = (params, payload) => {
        const {token, orderId, formId} = params;
        return api.patch(`v1/finance/${orderId}/loan-application/${formId}`, {...payload}, {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                SOURCE: deviceType
            }});
    };

    const postFinancePostPaymentApplication = (params, payload) => {
        const {token, orderId, formId} = params;
        return api.post(`v1/finance/${orderId}/loan-application/${formId}`, {...payload}, {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                SOURCE: deviceType
            }});
    };

    const patchFinanceUploadDocument = (params, payload) => {
        const {token, orderId, formId} = params;
        return api.patch(`v1/finance/${orderId}/loan-document/${formId}`, {...payload}, {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                SOURCE: deviceType
            }});
    };

    const postFinanceUploadDocument = (params, payload) => {
        const {token, orderId, formId} = params;
        return api.post(`v1/finance/${orderId}/loan-document/${formId}`, {...payload}, {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                SOURCE: deviceType
            }});
    };

    const financeUploadDocument = (params, payload) => {
        const {token, orderId} = params;
        return api.post(`finance/api/v1/${orderId}/upload-document`, payload, {
            headers: {
                "Content-Type": "multipart/form-data",
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                SOURCE: deviceType
            }});
    };

    const fetchBookedTasksList = (token) => {
        return api.get(`/v1/tasks`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const getPreSignedFinanceUploadedImage = (token, params) => {
        return api.get(`finance/api/v1/loan-document/preSigned`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            },
            params
        });
    };

    const updatePostBcStep = ({ token, orderId, step, action }) => {
        return api.put(
            `/v1/post-bc-journey/step`,
            {
                orderId,
                step,
                state: action || "complete"
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                    SOURCE: deviceType
                }
            }
        );
    };

    const getPostBcStep = ({ orderId, token }) => {
        return api.get(`/v1/post-bc-journey/step/${orderId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };
    const getInsuranceCmsContent = async ({ slug, orderId, appointmentId }) => {
        try {
            const response = await api.get(`/v1/cms/${slug}?orderId=${orderId}&appointmentId=${appointmentId}`, {
                headers: {
                    X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                    SOURCE: deviceType
                }
            });
            return response;
        } catch (error) {
            throw error;
        }
    };

    const fetchOrderDetailsApi = (orderId) => {
        return api.get(`/price/communication/${orderId}`
        );
    };

    const fetchPickupDetailsApi = (token, orderId, pincode) => {
        return api.get(`/price/communication/hub/pickup/details?orderId=${orderId}${pincode ? `&pincode=${pincode}` : ``}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
    };

    const acceptOrderApi = (token, orderId, payload) => {
        return api.put(`/price/communication/accept/sell?orderId=${orderId}`, payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
    };

    const fetchSlotDetailsApi = (token) => {
        return api.get(`/price/communication/slot`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );
    };

    const postRoadworthyCertificateInspectionDetails = (params, payload) => {
        const {token} = params;
        return api.post(`v1/oms/service-order`, {...payload}, {
            headers: {
                ...(token ?  {Authorization: `Bearer ${token}`} : {}),
                SOURCE: deviceType
            }});
    };

    const getCmsContent = (params, token) => {
        const queryParams = Object.entries(params)
            .filter(([_, value]) => value !== undefined && value !== null)
            .map(([key, value]) => `${key}=${value}`)
            .join("&");
        const url = `/v1/cms/${params.slug}${queryParams ? `?${queryParams}&seo-url-path=${appUrl()}/${params.slug}` : ""}`;
        return api.get(url, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                ...(token ?  { Authorization: `Bearer ${token}` } : {})
            }
        });
    };

    const getPostBCDocuments = (orderId) => {
        const url = `/api/v1/post-bc-journey/order/${orderId}/attachment`;
        return api.get(url, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const regenTaxInvoice = (orderId) => {
        const url = `/api/v1/post-bc-journey/attachment/${orderId}`;
        return api.get(url, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const createServiceOrder = (data, token) => {
        return api.post(`v1/oms/service-order`, data, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
    };
    const getCarouselData = (params, token) => {
        const {type = "WISHLIST"} = params;
        return api.get(`/v1/carousel/${type}`, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });
    };

    const getCarouselStoreData = async function ({payload = [], secureToken = "", sortingVariant}) {
        try {
            const response = await api.post(`/v1/carousel`, payload, {
                headers: {
                    ...(secureToken && {Authorization: `Bearer ${secureToken}`}),
                    X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                    SOURCE: deviceType,
                    "X-Sorting-Variant": sanitizeItemsToLowercase(sortingVariant) || sanitizeItemsToLowercase(EXPERIMENT_TYPE.VARIANT_A)
                }
            });
            return response;
        } catch (e) {
            return { error: e };
        }
    };

    const getMilestoneData = ({token, orderId, params = {}}) => {
        const queryParams = formQueryParams(params);
        return api.put(`/v1/post-bc-journey/order/${orderId}/milestone${queryParams}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };
    const getOrderDocuments = (orderId, token) => {
        return api.get(`v1/post-bc-journey/order/${orderId}/attachment`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    };
    const getRegenTaxInvoice = (orderId, token) => {
        return api.get(`v1/post-bc-journey/order/${orderId}/tax-invoice`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    };

    const updateWishlistNote = (token, data) => {
        return api.put(`/v1/shortlist`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_COUNTRY: X_COUNTRY_CODE.AU,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR
            }
        });
    };

    const getPostBcJourneySlots = ({token, params, orderId}) => {
        const queryString = formQueryParams(params);
        return api.get(`/v1/post-bc-journey/order/${orderId}/slot${queryString}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };

    const fetchSharableWishlist = (params) => {
        const {Uid = ""} = params || {};
        return api.get(`/v1/shortlist/shared/${Uid}`, {
            headers: {
                X_COUNTRY: X_COUNTRY_CODE.AU,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR
            }
        });
    };

    const bookPostBcJourneySlots = ({token, orderId, payload}) => {
        const {product = "DELIVERY"} = payload || {};
        return api.post(`/v1/post-bc-journey/order/${orderId}/${product}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };
    const fetchWishlistCars = (token, params) => {
        const version = params.wishlistAdoptionVariant ? "v2" : "secure/v1";
        return api.get(`${version}/shortlist`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            params
        });
    };
    const getPreBcMilestone = ({token, orderId, params = {}}) => {
        const queryParams = formQueryParams(params);
        return api.get(`/v1/pre-bc-journey/order/${orderId}/milestone${queryParams}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const getCarouselDataCarTour = (payload) => {
        return api.post(`/v1/carousel`, payload);
    };

    const getServiceCentres = ({ orderId, token, params }) => {
        const apiUrl = `/v1/network-centre/order/${orderId}${formQueryParams(params)}`;

        return api.get(apiUrl, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                X_COUNTRY: X_COUNTRY_CODE.AU,
                SOURCE: deviceType,
                Authorization: `Bearer ${token}`
            }
        });
    };

    const submitOrderIdYardVisit = (orderId, payload) => {
        return api.post(`/v1/yard-checkin-journey/${orderId}`, payload, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const submitWalkInYardVisit = (payload) => {
        return api.post(`/v1/yard-checkin-journey/walkin/submit`,
            payload,
            {
                headers: {
                    X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                    SOURCE: deviceType
                }
            }
        );
    };

    const confirmEmail = (payload) => {
        return api.post(`/v1/yard-checkin-journey/walkin/confirm`, payload, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };
    const fetchRegoDetails = ({params = {}, token = "" }) => {
        const queryString = formQueryParams(params || {});
        return api.get(`/v1/vehicle/kbb-details${queryString}`, {
            headers: {
                ...(token && {Authorization: `Bearer ${token}`}),
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };

    const fetchChrRegoDetails = ({params = {}, token = "" }) => {
        const queryString = formQueryParams(params || {});
        return api.get(`/v1/chr/vehicle/details${queryString}`, {
            headers: {
                ...(token && {Authorization: `Bearer ${token}`}),
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };

    const createChrServiceOrder = ({payload = {}, token = ""}) => {
        return api.post(`/v1/CHR`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };

    const fetchChrLandingData = ({orderId = "", token = ""}) => {
        return api.get(`v1/chr/order/${orderId}/landing-page`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };

    const searchChrServiceOrder = ({token}) => {
        return api.get(`/v1/CHR`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };

    const updateChrServiceOrder = ({orderId, token, payload = {}}) => {
        return api.patch(`v1/chr/order/${orderId}`, payload, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };

    const getChrServiceOrder = ({orderId, token}) => {
        return api.get(`v1/oms/service-order/${orderId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };

    const chrServiceOrderPayment = ({orderId, token, payload}) => {
        return api.put(`v1/chr/${orderId}/au/payments`, {...payload},  {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };

    const getAllChrOrders = (params, token) => {
        const queryString = formQueryParams(params || {});
        return api.get(`/v1/CHR/all${queryString}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                X_COUNTRY: X_COUNTRY_CODE.AU
            }
        });
    };

    const fetchInspectionReportDataApiDownload = ({orderId, token}) => {
        return api.get(`/v1/chr/order/${orderId}/download-report`, {
            headers: {
                Authorization: `Bearer ${token}`,
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const getDealerInfo = ({dealerId}) => {
        return api.get(`/v1/dealer?dealerId=${dealerId}`, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const getDealerConfig = ({dealerId}) => {
        return api.get(`/v1/dealer/config?dealerId=${dealerId}`, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType
            }
        });
    };

    const getSEOData = ({params = {}, payload = "", userGeoData = {}, sortingVariant = ""}) => {
        return api.get(`/v1/seo-cms/buy-used-cars?spath=${params.spath}&${payload}`, {
            headers: {
                X_VEHICLE_TYPE: X_VEHICLE_TYPE.CAR,
                SOURCE: deviceType,
                "X-Location-Data": JSON.stringify(userGeoData || {}),
                "X-Sorting-Variant": sanitizeItemsToLowercase(sortingVariant) || sanitizeItemsToLowercase(EXPERIMENT_TYPE.VARIANT_A)
            }
        });
    };

    return {
        getCheckoutSteps,
        createCheckoutSteps,
        updateCheckoutSteps,
        getTestDriveSteps,
        createTestDriveSteps,
        updateTestDriveSteps,
        getBookingSummary,
        cancelOrder,
        getDeliveryAvailability,
        fetchNudgeList,
        closeNudgeList,
        fetchBookedTasksList,
        getInhousePreApprovalLoanDetails,
        getInhouseEligibility,
        updateInhousePreApprovalLoan,
        submitInhousePreApprovalLoan,
        inHouseFinanceFirstFinancePollApi,
        createTestDriveAvailability,
        fetchInspectionReportDataApi,
        fetchFilters,
        updateC2bTrade,
        getDepositRangeValueInHouse,
        getSellbookings,
        getUnbookedSellbooking,
        submitC2bTrade,
        fetchListing,
        fetchCarPricing,
        getFinancePostPaymentApplication,
        patchFinancePostPaymentApplication,
        postFinancePostPaymentApplication,
        patchFinanceUploadDocument,
        postFinanceUploadDocument,
        financeUploadDocument,
        getPreSignedFinanceUploadedImage,
        updatePostBcStep,
        getPostBcStep,
        getCmsContent,
        getInsuranceCmsContent,
        fetchOrderDetailsApi,
        fetchPickupDetailsApi,
        acceptOrderApi,
        fetchSlotDetailsApi,
        createServiceOrder,
        postRoadworthyCertificateInspectionDetails,
        getCarouselData,
        updateWishlistNote,
        fetchSharableWishlist,
        getPostBCDocuments,
        regenTaxInvoice,
        getMilestoneData,
        getOrderDocuments,
        getRegenTaxInvoice,
        getPostBcJourneySlots,
        bookPostBcJourneySlots,
        fetchRegoDetails,
        fetchChrRegoDetails,
        createChrServiceOrder,
        fetchChrLandingData,
        searchChrServiceOrder,
        updateChrServiceOrder,
        getChrServiceOrder,
        chrServiceOrderPayment,
        fetchWishlistCars,
        getCarouselDataCarTour,
        getPreBcMilestone,
        getServiceCentres,
        submitOrderIdYardVisit,
        submitWalkInYardVisit,
        confirmEmail,
        getAllChrOrders,
        fetchInspectionReportDataApiDownload,
        getCarouselStoreData,
        getSEOData,
        getDealerInfo,
        getDealerConfig
    };
};
